module.exports = __webpack_public_path__ + "img/mental-health-animate.707a0da9.svg";